export const DONATION_TYPES = {
    ONE_TIME: 'one_time',
    MONTHLY: 'monthly',
    YEARLY: 'yearly'
}